// Import/Export memo-data.json <-> Y.Doc
import { createNode, getNodesMap, getRootOrder, getSettings, getTrash, getMeta, getAllNodes } from './yjs/doc.js';

export async function importFromFile(doc) {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json';
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return resolve(false);
      if (file.size > 50 * 1024 * 1024) {
        return reject(new Error('ファイルサイズが大きすぎます（上限50MB）'));
      }
      try {
        const text = await file.text();
        const data = JSON.parse(text);
        importData(doc, data);
        resolve(true);
      } catch (err) {
        reject(err);
      }
    };
    input.click();
  });
}

export function importData(doc, data) {
  const { nodes, rootOrder, expanded, selectedId, trash, settings } = data;

  doc.transact(() => {
    // Import nodes
    if (nodes) {
      Object.values(nodes).forEach((n) => {
        createNode(doc, {
          id: n.id,
          type: n.type,
          name: n.name,
          parentId: n.parentId,
          content: n.content,
        });

        // Restore childOrder for folders
        if (n.type === 'folder' && n.childOrder) {
          const nodeMap = getNodesMap(doc).get(n.id);
          const childOrder = nodeMap.get('childOrder');
          n.childOrder.forEach((cid) => childOrder.push([cid]));
        }
      });
    }

    // Import rootOrder
    if (rootOrder) {
      const yRootOrder = getRootOrder(doc);
      rootOrder.forEach((id) => yRootOrder.push([id]));
    }

    // Import settings
    if (settings) {
      const ySettings = getSettings(doc);
      Object.entries(settings).forEach(([k, v]) => ySettings.set(k, v));
    }

    // Import trash
    if (trash) {
      const yTrash = getTrash(doc);
      Object.entries(trash).forEach(([k, v]) => yTrash.set(k, JSON.stringify(v)));
    }

    // Import meta
    const yMeta = getMeta(doc);
    if (selectedId) yMeta.set('selectedId', selectedId);
    if (expanded) yMeta.set('expanded', JSON.stringify(expanded));
  });
}

export function exportToFile(doc) {
  const nodes = getAllNodes(doc);
  const rootOrder = getRootOrder(doc).toArray();
  const settingsMap = getSettings(doc);
  const settings = {};
  settingsMap.forEach((v, k) => { settings[k] = v; });
  const trashMap = getTrash(doc);
  const trash = {};
  trashMap.forEach((v, k) => { try { trash[k] = JSON.parse(v); } catch {} });
  const meta = getMeta(doc);
  const selectedId = meta.get('selectedId') || null;
  const expanded = (() => { try { return JSON.parse(meta.get('expanded') || '[]'); } catch { return []; } })();

  const data = { nodes, rootOrder, settings, trash, selectedId, expanded, exportedAt: new Date().toISOString() };
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `memo-backup-${new Date().toISOString().slice(0, 10)}.json`;
  a.click();
  URL.revokeObjectURL(a.href);
}

// Try to detect existing note8.html data in IndexedDB
export async function detectLegacyData() {
  return new Promise((resolve) => {
    const req = indexedDB.open('memo-app-handles', 1);
    req.onupgradeneeded = (e) => {
      // DB didn't exist before, close and delete
      e.target.transaction.abort();
      resolve(false);
    };
    req.onsuccess = (e) => {
      const db = e.target.result;
      try {
        const tx = db.transaction('handles', 'readonly');
        const getReq = tx.objectStore('handles').get('dir');
        getReq.onsuccess = () => resolve(!!getReq.result);
        getReq.onerror = () => resolve(false);
      } catch {
        resolve(false);
      }
    };
    req.onerror = () => resolve(false);
  });
}
